export const base = '/v1/';

export const talksApi = base + 'talks';

export const talkImageApi = base + 'images/talks';
export const insightsImageApi = base + 'images/insights';
